angular.module("ainapp")
    .controller("addCPVMasterController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Add Cash Payment";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.VDesign = {};
            MainService.VoucherDesignsbyType("Cash Payment").then(function (response) {
                $scope.VDesign = response.data;
            });

            $scope.PrintSetting = {};
            MainService.PrintSettingsbyType("Cash Payment").then(function (response) {
                $scope.PrintSetting = response.data;
            });

            $scope.TableDesign = {};
        $scope.ColumnWidth = null;
        MainService.TableDesignsbyVoucher("Cash Payment").then(function (response) {
             if (response.data != null && response.data != "") {
                $scope.TableDesign = response.data;
                $scope.ColumnWidth = JSON.parse(response.data.ColumnWidth);
            }
        });

            $scope.getExtramasters();

            $scope.loadVoucher = function (data) {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetCPV(data).then(function (response) {
                    if (response.data) {
                        $scope.UpdateDetails(response.data[0]);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("NetworkError");
                })
            }

            $scope.UpdateDetails = function (data) {

                $scope.CurrentCPV = data;
                $scope.CurrentCPV.Date = new Date($scope.CurrentCPV.Date);
                $scope.VoucherDocs = data.VoucherDocs;

                angular.forEach(data.CPVMasterCosts, function (e) {
                    angular.forEach($scope.CostCenters, function (a) {
                        if (e.CostCenter.ParentId == a.CostCenterId) {
                            a.SelectedCostCenterId = e.CostCenter.Id;
                        }
                    })
                })


                $scope.tempTotalQty = 0;
                $scope.tempUnitPrice = 0;
                $scope.tempGross = 0;
                $scope.tempDiscount = 0;
                $scope.tempVat = 0;

                angular.forEach($scope.CurrentCPV.CPVDetails, function (e) {
                    $scope.tempTotalQty = $scope.tempTotalQty + e.Quantity;
                    $scope.tempUnitPrice = $scope.tempUnitPrice + e.UnitPrice;
                    $scope.tempGross = $scope.tempGross + e.Total;
                    $scope.tempDiscount = $scope.tempDiscount + e.Discount;
                    $scope.tempVat = $scope.tempVat + e.TaxValue;


                    var costs = angular.copy($scope.CostCenters);
                    if (e.CPVMasterCosts.length > 0) {
                        angular.forEach(e.CPVMasterCosts, function (ee) {
                            angular.forEach(costs, function (a) {
                                if (ee.CostCenter.ParentId == a.CostCenterId) {
                                    a.SelectedCostCenterId = ee.CostCenter.Id;
                                }
                            })
                            e.CostCenters = angular.copy(costs);
                        })
                    } else {
                        e.CostCenters = angular.copy($scope.CostCenters);
                    }


                });

                if (data.CPVDetails.length <= 5) {

                    var temp2 = 5 - data.CPVDetails.length;

                    for (var i = 0; i < temp2; i++) {

                        var CPVDetails = {

                            Id: 0,
                            AccountId: "",
                            Amount: 0,
                            Description: "",
                            Account: {},
                            CostCenters: angular.copy($scope.CostCenters),


                        }

                        $scope.CurrentCPV.CPVDetails.push(CPVDetails);
                    }
                }

                console.log($scope.CurrentCPV.VehicleCategoryId);
                if ($scope.CurrentCPV.VehicleCategoryId > 0) {
                    $scope.getVehicles();
                }
            }

            $scope.expand = function () {
                $scope.expandView = !$scope.expandView;
            }

            $scope.VoucherSet = {};
            MainService.VoucherAccountsbyType('Cash Payment').then(function (response) {
                $scope.VoucherSet = response.data;
            })

            $scope.Currencies = [];
            MainService.CurrencyInDropdown().then(function (response) {
                $scope.Currencies = response.data;
            })

 $scope.tableReorderColumnArray = [];
            $scope.ReArrangeTable = function () {
                $scope.RearrangeReqired = false;
                $scope.tableReorderColumnArray = [];

                if ($scope.ColumnWidth != null) {
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        let key = cell.getAttribute('data-key');
                        if ($scope.ColumnWidth[key] !== undefined) {
                            cell.style.width = $scope.ColumnWidth[key] + "px";
                        }
                    });
                } else {
                    toastr.info("Table Width Adjustment Empty, Applying Default Width")
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        cell.style.width = "100px";
                    });
                }
            };

            $scope.Init = function () {

                $scope.expandView = false;

                $scope.ViewVal = 0;
                var tdate = new Date();
                var year = tdate.getFullYear();
                var month = tdate.getMonth();
                var day = tdate.getDate();
                var ndate = new Date(year + 1, month, day);

                $scope.print = {
                    IsPrint: false,
                }

                $scope.CurrentCPV = {
                    Date: new Date(),
                    Remarks: "",
                    VoucherNumber: "",
                    Total: 0,
                    Id: 0,
                    AccountId: "",
                    AccountName: "",
                    CPVDetails: [],
                    BaseCurrencyId: "",
                }



                for (var i = 0; i < 5; i++) {

                    var CPVDetails = {
                        Id: 0,
                        AccountId: "",
                        Amount: 0,
                        Description: "",

                        Account: {},
                        Flats: [],
                    }

                    $scope.CurrentCPV.CPVDetails.push(CPVDetails);
                }

                $scope.ErrorText = "";
                $scope.Load = false;




                $scope.CompanyProfile = {};
                if ($stateParams.VoucherId > 0) {
                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;
                        $scope.CostCenters = {};
                        MainService.CostCentersInVoucher("Cash Payment").then(function (response) {
                            $scope.CostCenters = response.data;
                            $scope.loadVoucher($stateParams.VoucherId);
                        });
                    })
                } else {
                    $scope.CompanyProfile = {};
                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;
                        $scope.CurrentCPV.BaseCurrencyId = $scope.CompanyProfile.BaseCurrencyId;

                        MainService.VoucherAccountsInVoucher("Cash Payment").then(function (res) {
                            $scope.CurrentCPV.Account = res.data.CreditAccount;
                            $scope.CurrentCPV.AccountId = res.data.CreditAccountId;
                        }, function (err) {
                            toastr.error("Network Error While Loading Account Settings");
                        })

                        $scope.CostCenters = {};
                        MainService.CostCentersInVoucher("Cash Payment").then(function (response) {
                            $scope.CostCenters = response.data;
                            angular.forEach($scope.CurrentCPV.CPVDetails, function (e) {
                                e.CostCenters = angular.copy($scope.CostCenters);
                            })
                        });

                        if ($scope.CompanyProfile.IsPaymentSingleSerialNo) {
                            MainService.GetNextPaymentVoucherNo().then(function (response) {
                                $scope.CurrentCPV.VoucherNumber = response.data;
                            });
                        } else {
                            MainService.GetNextCPVMasterNo().then(function (response) {
                                $scope.CurrentCPV.VoucherNumber = response.data;
                            });
                        }


                    })

                }

                 setTimeout(function () {
                    $scope.ReArrangeTable();
                }, 2000);

            }
            $scope.Init();

            $scope.PaidFromAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }

                        o.data.LoadType = "Head";
                        o.data.VoucherName = "Cash Payment";
                        MainService.LoadAccountsInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };

            $scope.PaidFromAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCPV.AccountId = data.Id;
                    $scope.CurrentCPV.Account = data;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.PaidFromAutocompleteDataSource
            };

            $scope.AccountAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        o.data.LoadType = "Body";
                        o.data.VoucherName = "Cash Payment";
                        MainService.LoadAccountsInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };

            $scope.AccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.AccountId = data.Id;
                    $scope.SelectedCE.Account = data;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.AccountCodeAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "AccountCode",
                dataTextField: "AccountCode",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.AccountId = data.Id;
                    $scope.SelectedCE.Account = data;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

          $scope.getBills = function (data) {

                $scope.SelectedCE = data;

                if (data.Account.TypeName == "Creditors" || data.Account.TypeName == "Debtors") {
                    data.UnassignedBillsArray = [];
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.GetPendingBillAnalysis(data.AccountId, "Payment").then(function (response) {
                        if (response.data != null) {
                            if (response.data.length > 0) {
                                data.UnassignedBillsArray = response.data;

                                if (data.Id > 0) {
                                    if (data.UnassignedBillsArrays.length > 0) {
                                        angular.forEach(data.UnassignedBillsArrays, function (e) {
                                            data.UnassignedBillsArray.unshift(e);
                                        })
                                    }
                                }

                                // angular.forEach(data.Bills, function (e) {
                                //     e.Adjustment = 0;
                                //     e.TotalBalance = e.BalanceAmount - e.Adjustment;
                                // })

                                $scope.SelectedCE.AdjustedTotal = 0;
                                $scope.SelectedCE.BalanceAdjusted = data.Amount;
                                $scope.SelectedCE.UnAssignedAdjusted = 0;

                                //$scope.SelectedCE.GrandTotal = data.Amount;

                                angular.forEach(data.UnassignedBillsArray, function (e) {
                                    $scope.SelectedCE.UnAssignedAdjusted = $scope.SelectedCE.UnAssignedAdjusted + e.BalanceAmount;
                                })

                                // $scope.autoAdjust();
                                $('#unassignedModal').modal('show');

                            }
                            else {
                                if (data.Id > 0) {
                                    if (data.UnassignedBillsArrays.length > 0) {

                                        $scope.SelectedCE.UnassignedBillsArray = data.UnassignedBillsArrays;
                                        $scope.SelectedCE.AdjustedTotal = 0;
                                        $scope.SelectedCE.BalanceAdjusted = data.GrandTotal;
                                        $scope.SelectedCE.UnAssignedAdjusted = 0;
                                        angular.forEach(data.UnassignedBillsArray, function (e) {
                                            $scope.SelectedCE.UnAssignedAdjusted = $scope.SelectedCE.UnAssignedAdjusted + e.BalanceAmount;
                                            $scope.SelectedCE.AdjustedTotal = $scope.SelectedCE.AdjustedTotal + e.Adjustment;
                                            $scope.SelectedCE.BalanceAdjusted = $scope.SelectedCE.BalanceAdjusted - e.Adjustment;
                                        })
                                        $('#unassignedModal').modal('show');

                                    } else {
                                        //$scope.SaveWithConfirm();
                                        $('#unassignedModal').modal('show');
                                    }
                                } else {
                                    // $scope.SaveWithConfirm();
                                    $('#unassignedModal').modal('show');
                                }
                            }
                        } else {

                            if (data.Id > 0) {
                                if (data.UnassignedBillsArrays.length > 0) {

                                    $scope.SelectedCE.UnassignedBillsArray = data.UnassignedBillsArrays;

                                    $scope.SelectedCE.AdjustedTotal = 0;
                                    $scope.SelectedCE.BalanceAdjusted = data.GrandTotal;
                                    $scope.SelectedCE.UnAssignedAdjusted = 0;
                                    angular.forEach(data.UnassignedBillsArray, function (e) {
                                        $scope.SelectedCE.UnAssignedAdjusted = $scope.SelectedCE.UnAssignedAdjusted + e.BalanceAmount;
                                        $scope.SelectedCE.AdjustedTotal = $scope.SelectedCE.AdjustedTotal + e.Adjustment;
                                        $scope.SelectedCE.BalanceAdjusted = $scope.SelectedCE.BalanceAdjusted - e.Adjustment;
                                    })
                                    $('#unassignedModal').modal('show');

                                } else {
                                    toastr.warning("Unassigned Bills Not Found !");
                                }
                            } else {
                                toastr.warning("Unassigned Bills Not Found !");
                            }

                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                    });

                }

            }


            $scope.matchrow = function (index) {
                $scope.SelectedCE.AdjustedTotal = 0;
                $scope.BalanceAdjusted = 0;
                var row = $scope.SelectedCE.UnassignedBillsArray[index];
                row.Adjustment = 0;
                var tt = $scope.SelectedCE.Amount;
                var assigned = 0;
                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    assigned = assigned + e.Adjustment;
                })
                var bal = tt - assigned;
                if (bal > 0 && row.BalanceAmount > bal) {
                    row.Adjustment = bal;
                }
                if (bal > 0 && bal >= row.BalanceAmount) {
                    row.Adjustment = row.BalanceAmount;
                }
                $scope.SelectedCE.AdjustedTotal = assigned + row.Adjustment;
                $scope.SelectedCE.BalanceAdjusted = tt - $scope.SelectedCE.AdjustedTotal;
            }

            $scope.unmatchrow = function (index) {
                $scope.SelectedCE.AdjustedTotal = 0;
                $scope.SelectedCE.BalanceAdjusted = 0;
                var row = $scope.SelectedCE.UnassignedBillsArray[index];
                row.Adjustment = 0;
                var tt = $scope.SelectedCE.Amount;
                var assigned = 0;
                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    assigned = assigned + e.Adjustment;
                })
                var bal = tt - assigned;
                $scope.SelectedCE.AdjustedTotal = assigned + row.Adjustment;
                $scope.SelectedCE.BalanceAdjusted = tt - $scope.SelectedCE.AdjustedTotal;
            }

            $scope.autoAdjust = function () {

                $scope.SelectedCE.AdjustedTotal = 0;
                $scope.SelectedCE.BalanceAdjusted = 0;
                var tmp = $scope.SelectedCE.Amount;

                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    if (tmp > 0) {
                        if (e.BalanceAmount > tmp) {
                            e.Adjustment = tmp;
                            tmp = 0;
                        } else {
                            e.Adjustment = e.BalanceAmount;
                            tmp = tmp - e.BalanceAmount;
                        }
                        tmp = Math.round(tmp * 100) / 100;
                        //  e.TotalBalance = e.BalanceAmount - e.Adjustment;
                    }
                    $scope.SelectedCE.AdjustedTotal = $scope.SelectedCE.AdjustedTotal + e.Adjustment;
                })
                $scope.SelectedCE.BalanceAdjusted = $scope.SelectedCE.GrandTotal - $scope.SelectedCE.AdjustedTotal;
            }

            $scope.removeAdjustment = function () {
                $scope.SelectedCE.AdjustedTotal = 0;
                $scope.SelectedCE.BalanceAdjusted = 0;
                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    e.Adjustment = 0;
                })
                $scope.SelectedCE.BalanceAdjusted = $scope.SelectedCE.GrandTotal - $scope.SelectedCE.AdjustedTotal;
            }

            $scope.validateBill = function () {
                var totaladj = 0;
                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    totaladj = totaladj + e.Adjustment;
                })
                if (totaladj > $scope.SelectedCE.Amount) {
                    toastr.warning("Amount exeeding, Values will reset");
                    // angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    //     e.Adjustment = 0;
                    //     e.TotalBalance = e.BalanceAmount - e.Adjustment;
                    // })
                } else {
                    angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                        e.TotalBalance = e.BalanceAmount - e.Adjustment;
                    })
                }
            }


            $scope.click = function (data, temp) {

                $scope.SelectedCE = data;
                $scope.CurrentCPV.Total = 0;


                angular.forEach($scope.CurrentCPV.CPVDetails, function (e) {

                    $scope.CurrentCPV.Total = $scope.CurrentCPV.Total + e.Amount;

                });


                var a = $scope.CurrentCPV.CPVDetails.indexOf(data);

                if (($scope.CurrentCPV.CPVDetails.length - 1) == a) {
                    var CPVDetails = {
                        Id: "",
                        AccountId: "",
                        Amount: 0,
                        Description: "",
                        CostCenters: angular.copy($scope.CostCenters),

                        Account: {},
                    }

                    $scope.CurrentCPV.CPVDetails.push(CPVDetails);
                }
            }


            $scope.IsSavePrint = false;

            $scope.SaveVocuher = function (pval) {

                $scope.IsSavePrint = false;
                if (pval == 2) {
                    $scope.IsSavePrint = true;
                }

                $scope.ErrorText = "";

                $scope.CurrentCPV.DateString = $scope.extractDate($scope.CurrentCPV.Date);
                if ($scope.CurrentCPV.Field16 != null) {
                    $scope.CurrentCPV.F16DateString = $scope.extractDate($scope.CurrentCPV.Field16);
                }
                if ($scope.CurrentCPV.Field17 != null) {
                    $scope.CurrentCPV.F17DateString = $scope.extractDate($scope.CurrentCPV.Field17);
                }
                if ($scope.CurrentCPV.Field18 != null) {
                    $scope.CurrentCPV.F18DateString = $scope.extractDate($scope.CurrentCPV.Field18);
                }
                if ($scope.CurrentCPV.Field19 != null) {
                    $scope.CurrentCPV.F19DateString = $scope.extractDate($scope.CurrentCPV.Field19);
                }
                if ($scope.CurrentCPV.Field20 != null) {
                    $scope.CurrentCPV.F20DateString = $scope.extractDate($scope.CurrentCPV.Field20);
                }

                var count = 0;
                var count2 = 0;
                var costval = 0;
                var count22 = 0;
                angular.forEach($scope.CurrentCPV.CPVDetails, function (e) {
                    if ((e.AccountId > 0 && e.Amount <= 0) || (e.AccountId == "" && e.Amount > 0)) {
                        count = count + 1;
                    } else if (e.AccountId > 0 && e.Amount > 0) {
                        count2 = count2 + 1;
                    }

                    if (e.AccountId == "" && e.Amount == 0) {
                        count22 = count22 + 1;
                    }

                    if (e.Field16 != null) {
                        e.F16DateString = $scope.extractDate(e.Field16);
                    }
                    if (e.Field17 != null) {
                        e.F17DateString = $scope.extractDate(e.Field17);
                    }
                    if (e.Field18 != null) {
                        e.F18DateString = $scope.extractDate(e.Field18);
                    }
                    if (e.Field19 != null) {
                        e.F19DateString = $scope.extractDate(e.Field19);
                    }
                    if (e.Field20 != null) {
                        e.F20DateString = $scope.extractDate(e.Field20);
                    }

                    if (e.AccountId > 0 && e.Amount > 0) {
                        e.CPVMasterCosts = [];
                        angular.forEach(e.CostCenters, function (a) {
                            if (a.Section == "Body") {
                                if (a.IsMandatory && !a.SelectedCostCenterId > 0) {
                                    $scope.ErrorText = "Cost Center Not Selected For : " + a.CostCenter.Name;
                                } else {
                                    if (a.SelectedCostCenterId > 0) {
                                        var cst = {
                                            CostCenterId: a.SelectedCostCenterId,
                                        }
                                        e.CPVMasterCosts.push(cst);
                                        console.log(e);
                                    }
                                }
                            }
                        })
                    }

                    if (e.UnassignedBillsArray != null) {
                        var tot = 0;
                        angular.forEach(e.UnassignedBillsArray, function (bil) {
                            tot = tot + bil.Adjustment;
                        })
                        tot = Math.round(tot * 100) / 100;
                        if (e.Amount < tot) {
                            $scope.ErrorText = "Adjusted Amount Invalid Please Check " + e.Account.Name;
                        }else{
                            e.UnassignedBillsArrays = e.UnassignedBillsArray;
                        }
                    }


                })

                $scope.CurrentCPV.CPVMasterCosts = [];
                angular.forEach($scope.CostCenters, function (e) {
                    if (e.Section == "Head") {
                        if (e.IsMandatory && !e.SelectedCostCenterId > 0) {
                            $scope.ErrorText = "Cost Center Not Selected For : " + e.CostCenter.Name;
                        } else {
                            if (e.SelectedCostCenterId > 0) {
                                var cst = {
                                    CostCenterId: e.SelectedCostCenterId,
                                }
                                $scope.CurrentCPV.CPVMasterCosts.push(cst);
                            }
                        }
                    }
                })

                if ($scope.CurrentCPV.AccountId == "") {
                    $scope.ErrorText = "Select Account";
                } else if (count > 0) {
                    $scope.ErrorText = "Invalid Details";
                } else if (count2 == 0) {
                    $scope.ErrorText = "Invalid Details";
                } else if (count22 == $scope.CurrentCPV.CPVDetails.length) {
                    $scope.ErrorText = "Invalid Details";
                }

                if ($scope.VDesign != null) {
                    if ($scope.VoucherDocs.length == 0 && $scope.VDesign.IsAttachmentMandatory) {
                        $scope.ErrorText = "Attachment Missing";
                    }
                }

                if (!$scope.PageAccessInfo.IsAdd && !$scope.CurrentCPV.Id > 0) {
                    toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.CurrentCPV.Id > 0) {
                    toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");

                } else {
                    if ($scope.ErrorText == "") {
                        $('#saveModal').modal('show');
                    } else {
                        toastr.warning($scope.ErrorText);
                    }
                }


            }

            $scope.SaveWithConfirm = function () {
                $scope.Load = true;
                $scope.CurrentCPV.VoucherDocs = $scope.VoucherDocs;

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.addCpvMaster($scope.CurrentCPV).then(function (response) {
                    if (response.data.Message == "Success") {
                        $scope.Load = false;
                        toastr.success("Success");
                        $('#saveModal').modal('hide');
                        if ($scope.IsSavePrint == true) {
                            toastr.info("Printing");
                            $scope.PrintInvoice(response.data.Id, 'Cash Payment Voucher', $scope.CurrentCPV.VoucherNumber);
                        }
                        $scope.refreshpageSave();
                    } else {
                        $scope.Load = false;
                        toastr.warning(response.data.Message);
                    }
                    $('#mymodal2').modal('hide');
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("NetworkError");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                });
            }

            $scope.refreshpageSave = function () {

                if ($stateParams.VoucherId > 0) {
                    $state.go("CPVMaster");
                } else {
                    $scope.Init();
                }

            }

            $scope.ViewVouchers = function () {
                if (!$scope.TokenInfo.IsView && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info("You Dont Have Access To View Data, Please Contact Admin");
                } else {
                    viewCPVMasterFactory.select().then(function (_selectedReceipt) {
                        if (_selectedReceipt != null) {
                            loadViewDatas(_selectedReceipt);
                        }
                    })
                }
            }

            var loadViewDatas = function (_selectedReceipt) {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetCPV(_selectedReceipt.Id).then(function (response) {

                    $scope.CurrentCPV = response.data[0];

                    $scope.CurrentCPV.Date = new Date($scope.CurrentCPV.Date);
                    $scope.CurrentCPV.AccountName = $scope.CurrentCPV.Account.Name;

                    angular.forEach($scope.CurrentCPV.CPVDetails, function (e) {
                        if (e.BuildingId > 0) {
                            $scope.getFlats(e);
                        }
                        if (e.VehicleCategoryId > 0) {
                            $scope.getVehicles(e);
                        }

                    })


                    if ($scope.CurrentCPV.CPVDetails.length <= 5) {

                        var temp2 = 5 - $scope.CurrentCPV.CPVDetails.length;

                        if (temp2 > 0) {
                            for (var i = 0; i < temp2; i++) {

                                var CPVDetails = {
                                    Id: "",
                                    AccountId: "",
                                    Amount: 0,
                                    Description: "",
                                    Account: {},
                                    Flats: [],
                                }

                                $scope.CurrentCPV.CPVDetails.push(CPVDetails);
                            }
                        }

                    }


                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("NetworkError");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            };

            $scope.DeleteVoucher = function () {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    if ($scope.CurrentCPV.Id > 0) {
                        $('#deleteModal').modal('show');
                    }

                }
            }


            $scope.DeleteWithConfirm = function () {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteCPV($scope.CurrentCPV.Id).then(function (response) {
                        if (response.data.Message == "Success") {
                            toastr.success("Deleted");
                            $('#deleteModal').modal('hide');
                            $state.go("CPVMaster");
                        } else {
                            toastr.warning(response.data.Message);
                        }
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    },
                    function (err) {
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                        toastr.error("NetworkError");
                    })
            }


            $scope.getFlats = function (row) {
                $scope.Load = true;

                MainService.FlatsByBuildingId(row.BuildingId).then(function (response) {
                    row.Flats = response.data;
                    $scope.Load = false;

                }, function (err) {
                    $scope.Load = false;
                    toastr.error("NetworkError");
                })
            }




            //// for context menu

            $scope.ClickedRow = {};
            $scope.ShowContextMenu = function (data) {
                $scope.ClickedRow = data;
            }

            $scope.InsertRow = function () {

                var CPVDetails = {
                    Id: "",
                    AccountId: "",
                    Amount: 0,
                    Description: "",
                    CostCenters: angular.copy($scope.CostCenters),
                    Account: {},
                    Flats: [],
                }


                $scope.CurrentCPV.CPVDetails.push(CPVDetails);

            }

            $scope.deleteRow = function () {
                var index = $scope.CurrentCPV.CPVDetails.indexOf($scope.ClickedRow);
                $scope.CurrentCPV.CPVDetails.splice(index, 1);

                $scope.CurrentCPV.Total = 0;


                angular.forEach($scope.CurrentCPV.CPVDetails, function (e) {

                    $scope.CurrentCPV.Total = $scope.CurrentCPV.Total + e.Amount;

                });

            }

            $scope.GetBackCPVMaster = function (type) {
                var temp = 0;
                if ($scope.CurrentCPV.Id > 0) {
                    temp = $scope.CurrentCPV.Id;
                }
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetBackCPVMaster(temp, type).then(function (response) {
                    if (response.data > 0) {
                        $scope.loadVoucher(response.data)
                    } else {
                        $scope.Init();
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            }

            $scope.$on('refreshCostCenterDir', function (e, id) {
                angular.forEach($scope.CostCenters, function (cost) {
                    if (cost.CostCenterId == id) {
                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });
                        MainService.CostCenterSubList(id).then(function (response) {
                            if (response.data != null) {
                                cost.CostCenters = response.data;
                                angular.forEach($scope.CurrentCPV.CPVDetails, function (d) {
                                    angular.forEach(d.CostCenters, function (dd) {
                                        if (dd.CostCenterId == id) {
                                            dd.CostCenters = response.data;
                                        }
                                    })
                                })
                            }
                            $.LoadingOverlay("hide");
                        }, function () {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        })
                    }
                })
            });


            /////////////////// Attachment //////////////////

            $scope.VoucherDocs = [];
            $scope.initAttachment = function () {
                $scope.VAttachment = {
                    ExpiryDate: null,
                    FileName: "",
                    FilePath: "",
                    Remarks: "",
                    IsActive: true,
                }
            }
            $scope.initAttachment();

            $scope.addAttachmentList = function () {
                if ($scope.VAttachment.FilePath == "") {
                    toastr.warning("Upload File");
                } else if ($scope.VAttachment.FileName == "") {
                    toastr.warning("Enter File Name");
                } else {
                    $scope.VoucherDocs.push($scope.VAttachment);
                    $scope.initAttachment();
                }
            }

            $scope.removeAttachmentRow = function (data) {
                data.IsActive = false;
            }


            // file upload
            $scope.files = [];
            $scope.getFileDetails = function (e) {
                $scope.files = [];
                $scope.$apply(function () {
                    for (var i = 0; i < e.files.length; i++) {
                        $scope.files.push(e.files[i])
                    }
                });
                $scope.Load = true;
                $scope.uploadFiles();
            };
            $scope.remove = function (file) {
                var index = $scope.files.indexOf(file);
                $scope.files.splice(index, 1);
            }
            $scope.uploadFiles = function () {
                var data = new FormData();
                for (var i in $scope.files) {
                    data.append("uploadedFile", $scope.files[i]);
                }
                var objXhr = new XMLHttpRequest();
                objXhr.onreadystatechange = function () {
                    if (objXhr.readyState == XMLHttpRequest.DONE) {
                        if (objXhr.responseText != null && objXhr.responseText != "") {
                            $scope.VAttachment.FilePath = objXhr.responseText;
                            if ($scope.VAttachment.FilePath.includes("error")) {
                                $scope.VAttachment.FilePath = "";
                                toastr.error($scope.LanguageData.UploadError);
                            } else {
                                $scope.VAttachment.FilePath = objXhr.responseText;
                                toastr.success($scope.LanguageData.FileUploaded);
                            }
                        } else {

                        }
                    }
                }
                // objXhr.addEventListener("progress", updateProgress, false);
                objXhr.addEventListener("load", transferComplete, false);
                if ($scope.files.length > 0) {
                    toastr.info($scope.LanguageData.FileUploadingPleaseWait);
                    objXhr.open("POST", config.basePath + "UploadFiles");
                    objXhr.send(data);
                } else {
                    toastr.error($scope.LanguageData.UploadError);
                }
            }
            //function updateProgress(e) {
            //    if (e.lengthComputable) {
            //        document.getElementById('pro').setAttribute('value', e.loaded);
            //        document.getElementById('pro').setAttribute('max', e.total);
            //    }
            //}
            function transferComplete(e) {
                $scope.Load = false;
            }



            $scope.FieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            o.data.FieldVoucherName = "Credit Note SR";
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.FieldAutoComplete(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.FieldAutoCompleteOptions11 = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCPV.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions12 = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCPV.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions13 = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCPV.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions14 = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCPV.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions15 = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCPV.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };

            $scope.DFieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            o.data.FieldVoucherName = "Credit Note SR";
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.FieldAutoCompleteDetail(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.D11AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D12AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D13AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D14AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D15AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };




                }])
